import axios from "axios";
import { toast } from "react-toastify";
import { OdcNetwork } from "../../../../ViewModel/OdcNetwork";
import { removeOdcFromRoute } from "./RemoveOdcFromRoute";
import { EditProjectContextProps } from "../../../EditProjectContext";
import { projectUrls } from "../../../../../URL/ApplicationUrls";
import { combinedUrls } from "../../../../../URL/functions";

export async function deleteOdcOnClick(
  dataItem: OdcNetwork,
  ftlRouteId: number,
  projectId: number | undefined,
  editProjectContext: EditProjectContextProps
) {
  const { Id, Gsdb, NetworkType, OdcId } = dataItem;

  async function handleOdcDelete() {
    await deleteOdcRequest();
    removeOdcFromRoute(ftlRouteId, Id, editProjectContext);
  }

  async function deleteOdcRequest() {
    const url = combinedUrls(
      projectUrls.projectFtlRouteApiUrl({
        projectId,
        ftlRouteId,
      }),
      `/DeleteOdc/${OdcId}/${NetworkType}`
    );

    await axios.delete(url);
  }

  await toast.promise(handleOdcDelete(), {
    pending: "Pending",
    error: {
      render({ data }: { data: any }) {
        return data?.message;
      },
    },
    success: `${Gsdb}.${NetworkType} has been deleted`,
  });
}
